import './doughnut-chart.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSDoughnutChart } from './doughnut-chart';

components.register({
	selector: '.gs-DoughnutChart',
	controller: GSDoughnutChart
});
